// store — or. MyStore seller product manager and the Submit content-upload page.
export default {
  storeErrNameRequired: 'Maqaa oomishaa galchuun qaba.',
  storeErrCategoryRequired: 'Gosa galchuun qaba.',
  storeErrPriceInvalid: 'Gatii kan tokko ol ta’uun qaba.',
  storeErrStockInvalid: "Baay’ina kuusaa natti qaba malee jechuun qaba.",
  storeErrImageRequired: 'Suuraa oomishaa isa tokkoo olaan argadhu dhaqqabi.',
  storeErrMaxPhotos: 'Suuraa 5 caalaa hin qabu.',
  storeSaveFailed: 'Kuusuu hin danda’amne.',
  storeDeleteFailed: 'Haqiisuu hin danda’amne.',
  storeSalePrice: 'Gatii gurgurtii (ETB) — hir’isi yoo hin fudhanne duwwaa dhaafii',
  storeSelectCategory: 'Gosa filadhu...',
  storeSubcategory: 'Gosa xiqqaa',
  storeSelectSubcategory: 'Gosa xiqqaa filadhu...',
  storeIsPackage: '📦 Kun kutaa dhoonsaa dha',
  storePackageIntro: 'Kutaa dhoonsaa kana keessatti jiran qabsiiru dhaqqabi:',
  storePackageItemName: 'Maqaa qabsiiruu',
  storePackageAddItem: '+ Qabsiiruu kutaa dhoonsaa dhaabi',
  storeAvailableColors: 'Qulqullee argaman',
  storeTapCircles: '(qulqullee filachuuf goormii cuuqullee dhaqqabi)',
  storeAllColors: '🎨 Qulqullee hunda keessatti ni argama',
  storeShowInBazaar: '🛍️ Baazaaraatti argisi',
  storeBazaarNote: '(kana boodaan baazaraa qophuu qabaa irratti ilaalama — oomishan yeroo hundaa Magaalaa fuulaatti argama)',
  storeProductImages: 'Suuraawwan oomishaa *',
  storeUpToPhotos: '(suuraa 5 turedhaan)',
  storeCurrentPhotos: 'Suuraawwan ammaa:',
  storeUploadingPhotos: 'Suuraawwan fe’aa jira...',
  storePackageBadge: 'KUTAA DHOONSAA',
  storeStockLabel: 'Kuusaa',
  storeAwaitingApproval: '⏳ Madaallii adminnicha eegaa jira',

  subImgCountErr: 'Suuraalee 3 hanga 5 gidduutti filadhu.',
  subVidCountErr: 'Viidiyooz 3 hanga 5 gidduutti filadhu.',
  subVidDurationErr: 'Viidiyooz tokkoon tokkoon daqii’aa 1 caalaa hin taane.',
  subNameRequired: 'Karaa tokkoon tokkoon maqaa qabuu qaba.',
  subPathImages: (name) => `"${name}": suuraalee 3–5 filadhu.`,
  subPathVideos: (name) => `"${name}": viidiyooz 3–5 filadhu.`,
  subFixErrors: 'Dogoggoma fayilii qabxaa dura turee dhaqqabi.',
  subFailed: 'Galchuun hin danda’amne. Irra deebi’i.',
  subSuccessTitle: 'Milkaa’inaan dhaabbate!',
  subSuccessMsg: 'Gareen keenya qabiyyee kee madaalaa jira. Irra deebi’ifama.',
  subSubmitAnother: 'Kun biraa Galchi',
  subPageTitle: 'Qabiyyee Kee Galchi',
  subPageIntro: 'Qabiyyee daldalaa karaa tokkoon tokkoon keessatti fe’aa dhaqqabi.',
  subRules: '📋 Seeraa: Karaa tokkoon tokkoon suuraalee 3–5 fi viidiyooz 3–5 qabaachuu qaba. Viidiyooz tokkoon tokkoon daqii’aa 1 caalaa hin taane.',
  subPathHeading: (n) => `Karaa ${n}`,
  subRemove: 'Haqi',
  subPathName: 'Maqaa Karaa *',
  subPathNamePlaceholder: 'Fakkeenyaaf: Qabiyyee Bishaanii Manni',
  subDescription: 'Ibsa (dirqama miti)',
  subDescPlaceholder: 'Qabiyyee kanaa ibsa wabii tokko...',
  subImagesLabel: 'Suuraalee (3–5) *',
  subImagesSelected: (n) => `✓ Suuraalee ${n} filadhe`,
  subVideosLabel: 'Viidiyooz (3–5, tokkoon tokkoon daqii’aa 1 gabaabaa) *',
  subVideosSelected: (n) => `✓ Viidiyooz ${n} filadhe`,
  subAddPath: '+ Karaa biraa Dabalii',
  subSubmitting: 'Galchaa jira...',
  subSubmitPaths: (n) => `Karaalee ${n} Galchi`,
};